import { render } from "./boardDeleteModal.vue?vue&type=template&id=0524825e"
import script from "./boardDeleteModal.vue?vue&type=script&lang=js"
export * from "./boardDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__